// extracted by mini-css-extract-plugin
module.exports = {"deal":"last-deal_deal__dQaut","arrow":"last-deal_arrow__2R8mc"};